// 토스 정기결제(빌링) 클라이언트 SDK 래퍼.
// 운영자 가맹점 client key 사용.
import { loadTossPayments } from '@tosspayments/payment-sdk';
import { env } from './env';

export async function requestBillingAuth(params: {
  customerKey: string;
  customerEmail: string;
  customerName: string;
  successUrl: string;
  failUrl: string;
}) {
  if (!env.SUBSCRIPTION_TOSS_CLIENT_KEY) {
    throw new Error('SUBSCRIPTION_TOSS_CLIENT_KEY 가 설정되지 않았습니다');
  }
  const toss = await loadTossPayments(env.SUBSCRIPTION_TOSS_CLIENT_KEY);
  await toss.requestBillingAuth('카드', {
    customerKey: params.customerKey,
    customerEmail: params.customerEmail,
    customerName: params.customerName,
    successUrl: params.successUrl,
    failUrl: params.failUrl,
  });
}

export function customerKeyFor(shamanId: string): string {
  return `shaman_${shamanId}`;
}
